import ContentAddCircle from 'material-ui/svg-icons/content/add-circle';
import { arrayOf, func, object } from 'prop-types';
import { path } from 'ramda';
import React from 'react';
import { colors } from 'styles/provider';
import InfoDialog from '../../../InfoDialog';

import ContentColumns from '../../components/ContentColumns';
import ControlSteps from '../../components/ControlSteps';
import DoneItemsList from '../../components/DoneItemsList';
import TextAreaWithSuggestions from '../../components/TextAreaWithSuggestions';

import { bullet } from './View.less';

const addCircleStyle = {
  width: '3rem',
  height: '3rem',
  color: colors.clrSecondary,
  display: 'block',
};
const iconAreaStyle = {
  padding: '0 0.5rem 0 0',
};

// Placeholders, change these names to something more descriptive when they are defined somewhere
const suggestions = [
  'mean1',
  'mean2',
  'mean3',
  'mean4',
  'mean5',
  'mean6',
  'mean7',
  'mean8',
  'mean9',
  'mean10',
  'mean11',
  'mean12',
];
const suggestionsLocale = 'onlineRehabilitation.opts.';

const View8 = ({ documents }, { fm, fmString, formValues, onChange }) => {
  const getValue = (name, index) => path(['rehab3', name, index], formValues) || '';

  const onChangePlans = (name, index) => event => {
    const allValues = path(['rehab3', name], formValues) || ['', '', ''];
    const eventValue = path(['currentTarget', 'value'], event);
    // Copy array so that changes dont roll backwards
    const allValuesMapped = allValues.map(a => a);
    allValuesMapped[index] = eventValue;
    onChange({ [name]: allValuesMapped });
  };

  const addNewPlan = () => {
    const allValues = path(['rehab3', 'plannedChangesToManageFatigue'], formValues);
    const newIndex = Array.isArray(allValues) ? allValues.length : 3;
    onChangePlans('plannedChangesToManageFatigue', newIndex)({ currentTarget: { value: '' } });
  };

  const doneItems = [
    { locale: 'onlineRehabilitation.rehab3.fatigueTrackingResults', canUpdate: false },
    { locale: 'onlineRehabilitation.rehab3.fatigueHandlingGoals', canUpdate: false },
  ];

  const nearFutureTarget = path(['rehab3', 'nearFutureTarget'], formValues);

  const plans = path(['rehab3', 'plannedChangesToManageFatigue'], formValues) || [];

  const strongFatiqueFactors = path(['rehab3', 'strongFatiqueFactors'], formValues) || [];
  const mildFatiqueFactors = path(['rehab3', 'mildFatiqueFactors'], formValues) || [];

  const fsmcId = path(['rehab1', 'fsmc'], formValues);
  const fsmcDoc = fsmcId ? documents.find(d => d.documentId === fsmcId) : null;

  const sessionFinished = !!path(['rehab3', 'finished'], formValues);

  return (
    <ContentColumns
      firstColumn={
        <div>
          <h2>{fm('onlineRehabilitation.rehab3.8.header')}</h2>
          <br />
          <ControlSteps steps={{ nearFutureTarget: nearFutureTarget }} fm={fm} />
          <br />
          <span>{fm('onlineRehabilitation.rehab3.8.text')}</span>{' '}
          {fsmcDoc && <InfoDialog type="fsmc" document={fsmcDoc} fm={fm} />}
          <div>{fm('onlineRehabilitation.rehab3.8.text2')}</div>
          <TextAreaWithSuggestions
            header={fmString('onlineRehabilitation.rehab3.8.changeHeader', { n: 1 })}
            onChange={onChangePlans('plannedChangesToManageFatigue', 0)}
            value={getValue('plannedChangesToManageFatigue', 0)}
            name={'plannedChangesToManageFatigue'}
            textPlaceholder={fmString('onlineRehabilitation.rehab3.8.changePlaceholder', { n: 1 })}
            suggestions={suggestions}
            suggestionsLocale={suggestionsLocale}
            disabled={sessionFinished}
          />
          <TextAreaWithSuggestions
            header={fmString('onlineRehabilitation.rehab3.8.changeHeader', { n: 2 })}
            onChange={onChangePlans('plannedChangesToManageFatigue', 1)}
            value={getValue('plannedChangesToManageFatigue', 1)}
            name={'plannedChangesToManageFatigue'}
            textPlaceholder={fmString('onlineRehabilitation.rehab3.8.changePlaceholder', { n: 2 })}
            suggestions={suggestions}
            suggestionsLocale={suggestionsLocale}
            disabled={sessionFinished}
          />
          <TextAreaWithSuggestions
            header={fmString('onlineRehabilitation.rehab3.8.changeHeader', { n: 3 })}
            onChange={onChangePlans('plannedChangesToManageFatigue', 2)}
            value={getValue('plannedChangesToManageFatigue', 2)}
            name={'plannedChangesToManageFatigue'}
            textPlaceholder={fmString('onlineRehabilitation.rehab3.8.changePlaceholder', { n: 3 })}
            suggestions={suggestions}
            suggestionsLocale={suggestionsLocale}
            disabled={sessionFinished}
          />
          {plans.map((_, i) => {
            // Only map those added using the button
            if (i < 3) return null;
            return (
              <TextAreaWithSuggestions
                key={i}
                header={fmString('onlineRehabilitation.rehab3.8.changeHeader', { n: i + 1 })}
                onChange={onChangePlans('plannedChangesToManageFatigue', i)}
                value={getValue('plannedChangesToManageFatigue', i)}
                name={'plannedChangesToManageFatigue'}
                textPlaceholder={fmString('onlineRehabilitation.rehab3.8.changePlaceholder', { n: i + 1 })}
                suggestions={suggestions}
                suggestionsLocale={suggestionsLocale}
                disabled={sessionFinished}
              />
            );
          })}
          <br />
          {!sessionFinished && (
            <React.Fragment>
              <button
                style={{ display: 'flex', cursor: 'pointer', alignItems: 'center', border: 0, backgroundColor: '#fff' }}
                onClick={addNewPlan}
              >
                <div style={iconAreaStyle}>
                  <ContentAddCircle style={addCircleStyle} />
                </div>
                <h3>{fm('onlineRehabilitation.addChange')}</h3>
              </button>
              <br />
            </React.Fragment>
          )}
          <div>{fm('onlineRehabilitation.rehab3.8.send')}</div>
        </div>
      }
      secondColumn={
        <div>
          <DoneItemsList itemList={doneItems} />
          <br />
          <div>{fm('onlineRehabilitation.rehab3.8.side.recap')}</div>
          <br />
          <h3>{fm('onlineRehabilitation.rehab3.8.side.strong')}</h3>
          {strongFatiqueFactors.map(f => (
            <div key={f} style={{ display: 'flex', minHeight: '3rem', margin: '0.5rem 0', alignItems: 'center' }}>
              <div className={bullet} style={{ backgroundColor: colors.clrErrorDefault }} />
              {f}
            </div>
          ))}
          <br />
          <h3>{fm('onlineRehabilitation.rehab3.8.side.mild')}</h3>
          {mildFatiqueFactors.map(f => (
            <div key={f} style={{ display: 'flex', minHeight: '3rem', margin: '0.5rem 0', alignItems: 'center' }}>
              <div className={bullet} style={{ backgroundColor: colors.clrSuccessDefault }} />
              {f}
            </div>
          ))}
        </div>
      }
    />
  );
};

View8.contextTypes = {
  fm: func,
  fmString: func,
  formValues: object,
  onChange: func,
};
View8.propTypes = {
  documents: arrayOf(object),
};

export default View8;
